import React from "react";
import { Platform, View } from "react-native";
import {
  Text,
  useResponsive,
  Panel,
  Heading,
  Icon,
} from "@clearabee/ui-library-native";
import { styles } from "./ProductDetails.styles";
import { useTranslation } from "react-i18next";
import { Anchor } from "components/Core/Anchor/Anchor";
import { UseTooltipReturn } from "lib/hooks/useTooltip";
import { getEnv } from "lib/getEnv";
import { getProhibitedItems } from "lib/helpers/tooltipHelper";

interface ProhibitedItemsPanelProps {
  surchargeItems?: UseTooltipReturn["surchargeItems"];
  prohibitedItems?: UseTooltipReturn["prohibitedItems"];
  hasSurcharges?: boolean;
  isSkipJob?: boolean;
}

export const ProhibitedItemsPanel = ({
  hasSurcharges = false,
  surchargeItems = [],
  prohibitedItems = [],
  isSkipJob = false,
}: ProhibitedItemsPanelProps): React.ReactElement => {
  const { screens } = useResponsive();
  const [translate] = useTranslation();

  return (
    <Panel
      color="warning"
      shadow={Platform.OS === "web"}
      styles={[
        {
          padding: 0,
          flex: 1,
          justifyContent: "space-between",
          paddingBottom: isSkipJob ? 22 : 0,
        },
        screens.medium &&
          hasSurcharges && {
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
          },
      ]}
    >
      {!!surchargeItems.length && !prohibitedItems.length && screens.large && (
        <View style={styles.overlay} />
      )}
      <Heading
        fontSize="base"
        color="greyscale"
        styles={styles.prohibitedItemsHeading}
      >
        {translate("hwa.screens.productDetails.prohibitedItems.heading")}
      </Heading>

      {(Object.keys(getProhibitedItems(isSkipJob)) as string[]).map((item) => (
        <View
          key={item}
          style={[
            styles.prohibitedItem,
            prohibitedItems.includes(item) &&
              screens.large &&
              styles.selectedProhibitedItem,
          ]}
        >
          <View
            style={[
              styles.prohibitedIcon,
              prohibitedItems.includes(item) &&
                screens.large &&
                styles.selectedProhibitedIcon,
            ]}
          >
            <Icon.Close
              width={10}
              height={10}
              color={
                prohibitedItems.includes(item) && screens.large
                  ? "negative"
                  : "light"
              }
            />
          </View>
          <Text
            color={
              prohibitedItems.includes(item) && screens.large
                ? "light"
                : "greyscale"
            }
          >
            {translate(
              `hwa.screens.productDetails.prohibitedItems.${
                isSkipJob ? "skipList" : "list"
              }.${item}` as any,
            )}
          </Text>
        </View>
      ))}

      {!isSkipJob && (
        <View style={styles.contactUsPanel}>
          <Text>
            <Anchor
              routeName="Redirect"
              params={{
                url: `${getEnv("WEBSITE_URL")}/contact`,
              }}
              newTab
            >
              <Text
                styles={[
                  { fontFamily: "ProximaSemiBold" },
                  Platform.select({
                    default: {},
                    ios: { marginBottom: -2 },
                    android: { marginBottom: -5 },
                  }),
                ]}
                color="warning"
              >
                {translate("common.contactUs")}
              </Text>
            </Anchor>
            <Text color="warning">
              {" "}
              {translate("hwa.screens.productDetails.prohibitedItems.message")}
            </Text>
          </Text>
        </View>
      )}
    </Panel>
  );
};
